import type { FaireProductEntity } from "../../entity_types/product";

export const p_5a28q5za88: FaireProductEntity = {
  token: "p_5a28q5za88",
  type: "product",
  name: "Want A Day Wrapped In Blankets Hanging Decor",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/37b4fa1ecc27c4a0c98b6b4579c15458f30c3d337af99f73c95286915932cd75.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c83d3c40456cbef8482b783763c48c595b7407696373c5860512669d0aebaadb.jpeg",
    "https://cdn.faire.com/fastly/d13916420719ad1afd39a013288c67077936df61e14f1c8e5e840a56f0b1188f.jpeg",
    "https://cdn.faire.com/fastly/4fd066cf353b8e848ffd620607bd76d4ad6416efac42fdc7b4ad820d196dd755.jpeg"
  ],
  priceDollars: 8.5,
  description: "A ready to hang metal tin sign from our Slow Living Collection displaying a hand illustrated design of framed embroidery on a wall with a fun sentiment that reads \"I Just Want A Day Wrapped In Blankets And Quiet\" perfect for those who enjoy cozy home life. Cozy living sign features metal with embossed details for added dimension. Our Want A Day In Blankets metal wall décor is easy to hang against wall using the included mounting hardware and pre-drilled holes. A cozy living home accent that easily adds personality to any space.",
  tags: [],
  msrpDollars: 16.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:27.867Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
